(function () {
  'use strict';

  function addDays(date, days) { var result = new Date(date); result.setDate(result.getDate() + days); return result; }
  function formatDate(date) { return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date); }
  function formatRange(first, last) { return formatDate(first) === formatDate(last) ? formatDate(first) : formatDate(first) + ' - ' + formatDate(last); }
  function region(country) { return country === 'US' ? 'us' : country === 'GB' ? 'uk' : 'global'; }
  function setOpen(element, open) { element.classList.toggle('is-open', open); element.setAttribute('aria-hidden', String(!open)); }

  function initialize(widget) {
    if (widget.dataset.shippingEstimateReady === 'true') return;
    widget.dataset.shippingEstimateReady = 'true';
    var data = widget.dataset, key = region(data.country || 'US');
    var processingMin = Number(data.processingMin) || 2, processingMax = Number(data.processingMax) || processingMin;
    var shippingMin = Number(data[key + 'ShippingMin']) || 7, shippingMax = Number(data[key + 'ShippingMax']) || shippingMin;
    var today = new Date(), shipMin = addDays(today, processingMin), shipMax = addDays(today, processingMax);
    var deliveryMin = addDays(today, processingMin + shippingMin), deliveryMax = addDays(today, processingMax + shippingMax);
    widget.querySelector('[data-shipping-order-date]').textContent = formatDate(today);
    widget.querySelector('[data-shipping-ship-date]').textContent = formatRange(shipMin, shipMax);
    widget.querySelector('[data-shipping-delivery-date]').textContent = formatRange(deliveryMin, deliveryMax);
    widget.querySelector('[data-shipping-delivery-range]').textContent = formatRange(deliveryMin, deliveryMax);

    var countdown = widget.querySelector('[data-dispatch-countdown]');
    if (countdown) {
      var countdownValue = countdown.querySelector('[data-dispatch-countdown-value]');
      var cutoffParts = String(data.dispatchCutoff || '23:59:59').split(':').map(Number);
      var cutoffHour = Number.isFinite(cutoffParts[0]) ? cutoffParts[0] : 23;
      var cutoffMinute = Number.isFinite(cutoffParts[1]) ? cutoffParts[1] : 59;
      var cutoffSecond = Number.isFinite(cutoffParts[2]) ? cutoffParts[2] : 59;
      var updateCountdown = function () {
        var now = new Date(), cutoff = new Date(now);
        cutoff.setHours(cutoffHour, cutoffMinute, cutoffSecond, 0);
        var remaining = Math.max(0, Math.floor((cutoff.getTime() - now.getTime()) / 1000));
        if (!remaining) {
          countdown.hidden = true;
          return;
        }
        var hours = Math.floor(remaining / 3600), minutes = Math.floor((remaining % 3600) / 60), seconds = remaining % 60;
        countdownValue.textContent = [hours, minutes, seconds].map(function (part) { return String(part).padStart(2, '0'); }).join(':');
      };
      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    }

    var trigger = widget.querySelector('[data-shipping-timeline-trigger]');
    var timeline = widget.querySelector('[data-shipping-timeline]');
    var backdrop = widget.querySelector('[data-shipping-timeline-backdrop]');
    var positionTimeline = function () {
      timeline.style.removeProperty('--shipping-timeline-offset');
      if (window.matchMedia('(max-width: 749px)').matches) return;
      var gutter = 16, rect = timeline.getBoundingClientRect(), offset = 0;
      if (rect.right > window.innerWidth - gutter) offset = window.innerWidth - gutter - rect.right;
      if (rect.left + offset < gutter) offset += gutter - (rect.left + offset);
      timeline.style.setProperty('--shipping-timeline-offset', Math.round(offset) + 'px');
    };
    var closeTimeline = function () { setOpen(timeline, false); timeline.style.removeProperty('--shipping-timeline-offset'); backdrop.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
    var openTimeline = function () { setOpen(timeline, true); positionTimeline(); trigger.setAttribute('aria-expanded', 'true'); if (window.matchMedia('(max-width: 749px)').matches) backdrop.classList.add('is-open'); };
    trigger.addEventListener('click', function () { timeline.classList.contains('is-open') ? closeTimeline() : openTimeline(); });
    trigger.addEventListener('mouseenter', function () { if (!window.matchMedia('(max-width: 749px)').matches) openTimeline(); });
    widget.querySelector('.shipping-estimate__eta-wrap').addEventListener('mouseleave', function () { if (!window.matchMedia('(max-width: 749px)').matches) closeTimeline(); });
    backdrop.addEventListener('click', closeTimeline);
    window.addEventListener('resize', function () { if (timeline.classList.contains('is-open')) positionTimeline(); });

    var countryTrigger = widget.querySelector('[data-shipping-country-trigger]');
    var dialog = widget.querySelector('[data-shipping-country-dialog]');
    if (countryTrigger && dialog) {
      var closeButton = dialog.querySelector('[data-shipping-country-close]');
      var closeDialog = function () { dialog.hidden = true; countryTrigger.setAttribute('aria-expanded', 'false'); countryTrigger.focus(); };
      countryTrigger.addEventListener('click', function () { dialog.hidden = false; countryTrigger.setAttribute('aria-expanded', 'true'); dialog.querySelector('[data-shipping-country-option][aria-current="true"], [data-shipping-country-option]').focus(); });
      closeButton.addEventListener('click', closeDialog);
      dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
      dialog.querySelectorAll('[data-shipping-country-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          var form = dialog.querySelector('form');
          form.querySelector('[data-shipping-country-input]').value = option.dataset.countryCode;
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      });
    }
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') { closeTimeline(); if (dialog && !dialog.hidden) closeDialog(); } });
  }
  function initializeAll(scope) { (scope || document).querySelectorAll('[data-shipping-estimate]').forEach(initialize); }
  document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  if (document.readyState !== 'loading') initializeAll(document);
}());
